import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  // Hoisted via useMemo so the navigation state object isn't a fresh
  // reference on every render (which would defeat React-Router's bail-out
  // memoisation downstream).
  const navState = useMemo(
    () => ({ from: location.pathname }),
    [location.pathname],
  );

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-50"
        data-testid="auth-loading"
      >
        <div className="text-slate-500 text-sm">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={navState} />;
  }

  return children;
}
